
import { useState } from 'react';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Estrategia y Consultoría Digital',
      description: 'Auditoría digital completa de tu marca y definición de estrategia de marketing digital adaptada a tus objetivos específicos.',
      features: ['Auditoría digital integral', 'Estrategia personalizada', 'Plan de contenidos', 'Análisis de competencia']
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Publicidad Online (Paid Media)',
      description: 'Gestión completa de campañas publicitarias en Google Ads, Social Ads y estrategias de retargeting para maximizar tu ROI.',
      features: ['Google Ads (SEM)', 'Social Ads (Facebook, Instagram, TikTok)', 'Retargeting avanzado', 'Optimización continua']
    },
    {
      icon: 'ri-search-line',
      title: 'Posicionamiento Orgánico (SEO)',
      description: 'Optimización integral de tu web para buscadores con estrategia de palabras clave y creación de contenidos optimizados.',
      features: ['SEO técnico avanzado', 'Estrategia de keywords', 'Contenidos optimizados', 'Link building']
    },
    {
      icon: 'ri-share-line',
      title: 'Social Media Marketing',
      description: 'Gestión completa de redes sociales con creación de contenido estratégico y community management profesional.',
      features: ['Gestión de perfiles', 'Estrategia de contenido', 'Diseño de creatividades', 'Community Management']
    },
    {
      icon: 'ri-palette-line',
      title: 'Branding y Diseño Web',
      description: 'Desarrollo de identidad visual de marca y diseño de páginas web optimizadas para conversión y experiencia de usuario.',
      features: ['Identidad visual completa', 'Diseño web responsive', 'UX/UI optimizado', 'Material gráfico']
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Marketing & Automatización',
      description: 'Campañas de email segmentadas y automatización de flujos de comunicación para nutrir leads y fidelizar clientes.',
      features: ['Campañas segmentadas', 'Newsletters personalizadas', 'Automatización de flujos', 'Integración CRM']
    },
    {
      icon: 'ri-code-line',
      title: 'Desarrollo Web y Ecommerce',
      description: 'Desarrollo de páginas web corporativas y tiendas online con las mejores tecnologías y optimización para conversión.',
      features: ['Desarrollo web custom', 'Tiendas online (Shopify, WooCommerce)', 'Optimización de conversión', 'Mantenimiento']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Analítica y Medición',
      description: 'Configuración de herramientas de análisis y creación de dashboards personalizados con KPIs relevantes para tu negocio.',
      features: ['Google Analytics 4', 'Dashboards personalizados', 'Informes mensuales', 'Propuestas de mejora']
    },
    {
      icon: 'ri-user-star-line',
      title: 'Influencer Marketing & PR Digital',
      description: 'Estrategias de colaboración con influencers y microinfluencers, además de relaciones públicas digitales para amplificar tu marca.',
      features: ['Colaboraciones con influencers', 'Microinfluencer marketing', 'PR digital', 'Gestión de relaciones']
    }
  ];

  const [selectedService, setSelectedService] = useState(0);

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Servicios Completos de Marketing Digital
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos un ecosistema completo de servicios de marketing digital para llevar tu negocio 
            al siguiente nivel con estrategias probadas y resultados medibles
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              onClick={() => setSelectedService(index)}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              
              <div className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-sm text-gray-5

00">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </div>
                ))}
              </div>
              
              <div className="flex justify-center">
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                  Más Información
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">¿Necesitas una solución integral?</h3>
            <p className="text-gray-600 mb-6">
              Creamos estrategias de marketing digital 360° combinando múltiples servicios 
              en un plan personalizado que se adapte perfectamente a tu negocio y presupuesto.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify

-center">
              <button 
                onClick={() => window.location.href = 'mailto:clientes@datametanoia.com?subject=Consulta sobre solución integral de marketing digital&body=Hola, me interesa obtener más información sobre sus servicios integrales de marketing digital. Me gustaría agendar una consulta gratuita para discutir mis necesidades específicas.'}
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-3 rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-line mr-2"></i>
                Solicitar Consulta Gratuita
              </button>
              <button 
                onClick={() => {
                  const message = encodeURIComponent('¡Hola! Me interesa una solución integral de marketing digital. ¿Podrían ayudarme con información sobre sus servicios completos?');
                  window.open(`https://wa.me/34685340545?text=${message}`, '_blank');
                }}
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-3 rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar Ahora
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md

-grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-blue-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-800 mb-2">Resultados Garantizados</h4>
            <p className="text-gray-600">Compromiso con resultados medibles en los primeros 90 días</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-purple-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-800 mb-2">Equipo Especializado</h4>
            <p className="text-gray-600">Profesionales certificados en todas las áreas del marketing digital</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg

-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-line text-green-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font

-semibold text-gray-800 mb-2">Soporte Continuo</h4>
            <p className="text-gray-600">Acompañamiento personalizado y soporte técnico 24/7</p>
          </div>
        </div>
      </div>
    </section>
  );
}
